import type { OrderFragment } from '#graphql-operations'

export function getSurchargesForOrderLine(order: OrderFragment, orderLineId: string | number): OrderFragment['surcharges'] {
  return order.surcharges.filter(surcharge => surcharge.orderLineId === orderLineId) || []
}

/**
 * Row label for a surcharge. An opt-in add-on reads as its own name ("Exalted
 * Priority & Care") rather than the backend's "<price> – <benefit line>"
 * description; every other surcharge (e.g. the cash-on-delivery fee) keeps it.
 *
 * Typed structurally so apps whose Surcharge fragment omits `details` still fit.
 */
export function surchargeLabel(surcharge: { name: string, details?: { name?: string | null, isAddOn?: boolean | null } | null }): string {
  return surcharge.details?.isAddOn && surcharge.details.name ? surcharge.details.name : surcharge.name
}
